export const SET_NAME = 'SET_NAME'

export const setName = (name: string) => {
  return {
    type: SET_NAME,
    name
  }
}